import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getValueFromStatus, getDutchExecutionDate } from '../../Helpers/Helpers';
import { useHasError } from '../../FormView/FormView';
import moment from 'moment';

import { ScoreInput } from '../../ScoreInput/ScoreInput.jsx';
import TextArea from '../../TextArea/TextArea';
import DatePickerUI from '../../DatePicker/DatePicker';
import { ToggleTrigger, ToggleContainer } from '../../Toggler/Toggler';

import Details, { DetailsItem, DetailsDivider } from '../../Details/Details';
import { TextField } from '@mui/material';

function FinishInspection (props) {
	const [state, setState] = useState({
		errorElements: props.errorElements || [],
		dutch_execution_date: getDutchExecutionDate(props.execution_date) || moment(new Date()).format('DD-MM-YYYY'),
		general_impression_description: props.general_impression_description || '',
		general_impression_status: props.general_impression_status || '',
		inspection_advised_maintenance: props.inspection_advised_maintenance,
		inspection_part_status_name: props.inspection_part_status_name,
	});
	const { t } = useSelector(redux => redux.store);
	const hasError = useHasError(props.errorElements);

	function handleDateChange (instance, date) {
		setState({
			dutch_execution_date: date.format('DD-MM-YYYY'),
		});
	}

	return (
		<div>
			<div className="inspection-part">
				<Details header={t.finish_general_impression} primary={true}>
					<div className="inspection-part__inputs grid-inline grid-inline-start">
						<DetailsItem label={t.score}>
							<ScoreInput
								error={hasError(
									'general_impression_status',
									t.generate_part_score_error)}
								className="score-input spacing-default-right"
								id="general_impression_status"
								name="general_impression_status"
								score={
									getValueFromStatus(state.general_impression_status)
								}
							/>
						</DetailsItem>
						<DetailsItem>
							<ToggleTrigger
								id="general_impression-trigger"
								targetId="general_impression-notes"
								active={!!state.general_impression_description}
							/>
						</DetailsItem>
					</div>
					<DetailsItem>
						<ToggleContainer id="general_impression-notes">
							<TextArea
								data-notrequired
								error={hasError(
									'general_impression_description',
									t.generate_part_notes_error,
								)}
								className="spacing_default-bottom"
								name="general_impression_description"
								triggerid="general_impression-trigger"
								value={state.general_impression_description}
								floatingLabelText={t.notes}
							/>
						</ToggleContainer>
					</DetailsItem>
				</Details>
				<DetailsItem
					label={t.finish_impression}
				>
					<ScoreInput
						error={hasError(
							'inspection_part_status_name',
							t.generate_part_score_error,
						)}
						className="score-input spacing-default-right"
						id="inspection_part_status_name"
						name="inspection_part_status_name"
						score={
							getValueFromStatus(state.inspection_part_status_name)
						}
					/>
				</DetailsItem>
				<DetailsItem label={t.finish_recommended}>
					<TextField
						variant="standard"
						name="inspection_advised_maintenance"
						type="number"
						inputProps={{ 'data-notrequired': true }}
						defaultValue={state.inspection_advised_maintenance} />
				</DetailsItem>
				<DetailsDivider />
				<Details header={t.finish_execute} primary={true}>
					<DetailsItem label={t.date}>
						<DatePickerUI
							t={t}
							label={t.select_date}
							name="inspection_executed"
							value={state.dutch_execution_date}
							onChange={handleDateChange}
						/>
					</DetailsItem>
				</Details>
				<br />
				<DetailsDivider />
			</div>
			<br />
		</div>
	);
}

export default FinishInspection;
